import { Form } from "@rjsf/mui";
import validator from "@rjsf/validator-ajv6";
import { useState, useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Table from "../form/formComponents/Table";
import { store } from "../../redux/store";
import { useTranslation } from "react-i18next";

import ApartamentMeterTable from "./ApartamentMeterTable";
const ObjectFieldTemplate = (props) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="flex-end"
      rowSpacing={3}
      spacing={2}
    >
      {props.properties.map((element, i) => {
        /* if (i == 5 || i == 4) {
                      return (
                        <Grid key={element.id} alignItems="center" item xs={12}>
                          {element.content}
                        </Grid>
                      );
                    } */
        return (
          <Grid key={element.id} alignItems="center" item xs={6}>
            {element.content}
          </Grid>
        );
      })}
    </Grid>
  );
};
const typeEnum = [
  { const: "AFS" },
  { const: "ACS" },
  { const: "CALORIE / FRIGORIE" },
  /*   { const: "CC -H" }, */
  { const: "RIPARTITORE" },
];
const ApartamentMeter = () => {
  const [getByName, resp, lpi] = store.useLazyGetDataByNameQuery();
  const [firstRender, setFirstRender] = useState(true);
  const [getCondominiumShow] = store.useLazyCondominiumShowQuery();
  const { id, subCondominumName, apartmentName, serial } = useParams();
  const meterUpdatedFromCondominium = localStorage.getItem(
    "meterUpdatedFromCondominium"
  );
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const [perPage, setPerPage] = useState(12);
  const devices = useSelector((state) => state?.clusterSlice?.devices);
  useEffect(() => {
    const params = {
      page: page,
      per_page: perPage,
      /* class: "AltiorEdge", */
      /*  tag: "AltiorEdge", */
    };
    if (!firstRender) {
      getByName(["altior/device", { ...params }]);
    }
  }, [page]);
  useEffect(() => {
    console.log("respik", resp);
  }, [resp]);
  useEffect(() => {
    const params = {
      page: page,
      per_page: perPage,
      /* class: "AltiorEdge", */
      /*      tag: "AltiorEdge", */
    };
    if (firstRender && !resp.data) {
      getByName(["altior/device", { ...params }]);
      setFirstRender(false);
    }
  }, [firstRender, resp]);

  const schema = {
    title: "New apartment",
    type: "object",
    properties: {
      meter_type: {
        $id: "1",
        type: "string",
        title: t("type"),
        oneOf: [...typeEnum],
      },
      serial_number: {
        $id: "2",
        title: t("serial"),
        type: "string",
      },
    },
  };
  const uiSchema = {
    "ui:submitButtonOptions": {
      submitText: t("search"),
    },
    "ui:ObjectFieldTemplate": ObjectFieldTemplate,
  };
  const onSubmitClick = (obj) => {
    const params = {
      ...obj,
      page: page,
      per_page: perPage,
      /*   tag: "AltiorEdge", */
      /*   class: "AltiorEdge", */
    };
    getByName(["altior/device", { ...params }]);
  };
  return (
    <>
      <Box width={1300}>
        <Box sx={{ mt: 2 }}>
          <Form
            schema={schema}
            /*      fields={fields} */
            formData={formData}
            /*      customValidate={customValidate} */
            showErrorList={false}
            onChange={(changeEvent) => setFormData(changeEvent.formData)}
            onSubmit={(values) => {
              onSubmitClick(values.formData);
            }}
            validator={validator}
            uiSchema={uiSchema}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <ApartamentMeterTable
            data={resp?.data?.data}
            response={resp}
            perPage={perPage}
            page={page}
            setPage={setPage}
            /* hideAccordion={hideAccordion}  */
          />
        </Box>
      </Box>
    </>
  );
};
export default ApartamentMeter;
